import React from 'react';

function AgentWalkthrough() {
  return (
    <iframe
      src="/agent-portal-walkthrough.html"
      title="Agent Portal Walkthrough"
      style={{
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block'
      }}
    />
  );
}

export default AgentWalkthrough;
